import React from 'react';
import { Link } from 'react-router-dom';
import { Flame } from 'lucide-react';
import { SITE_IMAGES } from '../../components/siteImages';
export function FitnessAdult() {
  return <section className="py-24 bg-ink text-off-white" data-id="element-1376">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1377">
        <div className="grid lg:grid-cols-2 gap-16 items-center flex-col-reverse lg:flex-row" data-id="element-1378">
          <div className="order-2 lg:order-1" data-id="element-1379">
            <img src={SITE_IMAGES.adultClasses} alt="Adult Taekwondo fitness" className="block rounded-2xl shadow-2xl w-full object-cover aspect-[4/3]" data-id="element-1380" />
          </div>
          <div className="order-1 lg:order-2" data-id="element-1381">
            <div className="inline-flex items-center gap-2 bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-1382">
              <Flame className="w-4 h-4" data-id="element-1383" />
              Adult Programs
            </div>
            <h2 className="text-4xl md:text-5xl text-white mb-6" data-id="element-1384">
              Ditch the Boring Gym Routine
            </h2>
            <p className="text-lg text-gray-warm mb-6" data-id="element-1385">
              Tired of the treadmill? Adult Taekwondo classes at Storm offer a
              fun, engaging alternative to traditional gym workouts. You're not
              just burning calories; you're learning a valuable skill.
            </p>
            <p className="text-lg text-gray-warm mb-8" data-id="element-1386">
              Our adult classes are beginner-friendly and designed to challenge
              you at your current fitness level, helping you build real-world
              self-defense skills while getting in the best shape of your life.
            </p>
            <Link to="/karate-adult-classes" className="btn-primary" data-id="element-1387">
              Explore Adult Classes
            </Link>
          </div>
        </div>
      </div>
    </section>;
}